import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const PARENT_SELECTOR = '.js-horizontal-scroll';

const createScroll = (parentEl) => {
	const trigger = document.querySelector('main');
	const content = parentEl.querySelector('.js-horizontal-content');
	const item = parentEl.querySelector('.js-horizontal-item:last-child');
	const scrollWidth = () => item.getBoundingClientRect().right - window.innerWidth + (window.innerWidth - content.getBoundingClientRect().right);
	gsap.to(content, {
		x: () => -scrollWidth(),
		ease: 'none',
		scrollTrigger: {
			trigger,
			pin: true,
			scrub: 1,
			snap: 1,
			start: () => `${parentEl.offsetTop} center`,
			end: () => `+=${scrollWidth()}`,
			invalidateOnRefresh: true,
		}
	});
};

export const initHorizontalScroll = () => {
	const containers = document.querySelectorAll(PARENT_SELECTOR);
	if (containers.length === 0) return;

	containers.forEach(createScroll);
};
